import { withChartLayout } from 'components/common';
import Safety from 'components/features/chart/basic-nursing-care/safety/Safety';

const SafetyPage = withChartLayout('Safety')(Safety);
export default SafetyPage;
